import Gateway from '@/utils/Gateway';

const cacheData = {};

function setCacheDep(id, depList) {
    if (depList && depList.length > 0) {
        cacheData[id] = depList.map(item => {
            const { id: itemId, name, deps } = item || {};

            setCacheDep(itemId, deps);

            return {
                id: itemId,
                name
            };
        });
    }
}

function setCacheData(data) {
    const { id, deps } = data || {};

    setCacheDep(id, deps);
}

export default function(params) {
    return new Promise(resolve => {
        const { depId } = params;

        if (cacheData[depId]) {
            resolve({
                data: {
                    deps: cacheData[depId]
                }
            });
        } else if (depId === 0) {
            Gateway.get('/v1/wework/DepTree', {
                depId: 1
            }).then(data => {
                const { id, name } = data || {};
                cacheData[depId] = [{ id, name }];

                setCacheData(data);
                resolve({
                    data: {
                        deps: cacheData[depId]
                    }
                });
            });
        } else {
            resolve({
                data: {
                    deps: []
                }
            });
        }
    });
}
